<template>
  <section>
    <ul class="filters-list">
      <li
        :class="{
          'router-link-active-parent': $route.name == 'viewprogress',
        }"
      >
        <router-link :to="{ name: 'viewprogress', query: this.$route.query }">
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ToStartResultFilesViewProgress',
            query: this.$route.query,
          }"
        >
          TO-START
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ProcessingResultFilesViewProgress',
            query: this.$route.query,
          }"
        >
          PROCESSING
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'FailedResultFilesViewProgress',
            query: this.$route.query,
          }"
        >
          FAILED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{ name: 'CompletedResultFiles', query: this.$route.query }"
        >
          COMPLETED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
